module.exports = __webpack_public_path__ + "img/imgProduct02.8b616ac4.jpg";